(function () {
  'use strict';

  if (window.LCMHomeVehicleRestoreInitialized) {
    return;
  }

  window.LCMHomeVehicleRestoreInitialized = true;

  var ROOT_SELECTOR = '[data-lcm-home-vehicle-selector]';
  var MAX_ATTEMPTS = 120;
  var RETRY_DELAY = 75;
  var apiRetryCount = 0;

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLocaleLowerCase();
  }

  function getActiveVehicle() {
    if (
      !window.LCMVehicle ||
      typeof window.LCMVehicle.getActive !== 'function'
    ) {
      return undefined;
    }

    return window.LCMVehicle.getActive();
  }

  function findOption(select, value) {
    var wanted = normalize(value);

    if (!select || !wanted) {
      return null;
    }

    return Array.prototype.find.call(select.options, function (option) {
      return option.value && normalize(option.value) === wanted;
    }) || null;
  }

  function getSelects(quickFilter) {
    return {
      make: quickFilter.querySelector('select[data-index="1"]'),
      model: quickFilter.querySelector('select[data-index="2"]')
    };
  }

  function updateNiceSelect(quickFilter, select) {
    if (!quickFilter || !select || !quickFilter.niceSelects) {
      return;
    }

    var selects = Array.prototype.slice.call(
      quickFilter.querySelectorAll('select.select__select')
    );
    var index = selects.indexOf(select);
    var niceSelect = quickFilter.niceSelects[index];

    if (niceSelect && typeof niceSelect.update === 'function') {
      niceSelect.update();
    }
  }

  function selectOption(quickFilter, select, option) {
    Array.prototype.forEach.call(select.options, function (item) {
      item.selected = item === option;
      item.removeAttribute('selected');
    });

    option.selected = true;
    option.setAttribute('selected', 'selected');
    select.value = option.value;

    updateNiceSelect(quickFilter, select);
    select.dispatchEvent(new Event('change', { bubbles: true }));
    updateNiceSelect(quickFilter, select);
  }

  function waitFor(test, root, restoreId, callback, attempt) {
    if (root.__lcmHomeRestoreId !== restoreId) {
      return;
    }

    var result = test();

    if (result) {
      callback(result);
      return;
    }

    if (attempt >= MAX_ATTEMPTS) {
      return;
    }

    window.setTimeout(function () {
      waitFor(test, root, restoreId, callback, attempt + 1);
    }, RETRY_DELAY);
  }

  function restoreVehicle(root, vehicle) {
    if (!root || !vehicle || !vehicle.make || !vehicle.model) {
      return;
    }

    var restoreId = (root.__lcmHomeRestoreId || 0) + 1;
    root.__lcmHomeRestoreId = restoreId;

    waitFor(
      function () {
        var quickFilter = root.querySelector(
          'quick-filter[data-mode="filter"]'
        );

        if (!quickFilter || !quickFilter.niceSelects) {
          return null;
        }

        var selects = getSelects(quickFilter);
        var makeOption = findOption(selects.make, vehicle.make);

        if (!selects.make || !selects.model || !makeOption) {
          return null;
        }

        return {
          quickFilter: quickFilter,
          selects: selects,
          makeOption: makeOption
        };
      },
      root,
      restoreId,
      function (context) {
        var currentMake = normalize(context.selects.make.value);
        var wantedMake = normalize(context.makeOption.value);
        var currentModelOption = findOption(
          context.selects.model,
          vehicle.model
        );

        if (
          currentMake !== wantedMake ||
          context.selects.model.disabled ||
          !currentModelOption
        ) {
          selectOption(
            context.quickFilter,
            context.selects.make,
            context.makeOption
          );
        }

        waitFor(
          function () {
            var modelOption = findOption(
              context.selects.model,
              vehicle.model
            );

            if (context.selects.model.disabled || !modelOption) {
              return null;
            }

            return modelOption;
          },
          root,
          restoreId,
          function (modelOption) {
            if (
              normalize(context.selects.model.value) !==
              normalize(modelOption.value)
            ) {
              selectOption(
                context.quickFilter,
                context.selects.model,
                modelOption
              );
            } else {
              updateNiceSelect(
                context.quickFilter,
                context.selects.model
              );
            }

            root.setAttribute(
              'data-lcm-home-vehicle-restored',
              vehicle.make + '|' + vehicle.model
            );
          },
          0
        );
      },
      0
    );
  }

  function clearVehicle(root) {
    var restoreId = (root.__lcmHomeRestoreId || 0) + 1;
    root.__lcmHomeRestoreId = restoreId;

    waitFor(
      function () {
        var quickFilter = root.querySelector(
          'quick-filter[data-mode="filter"]'
        );

        if (!quickFilter || !quickFilter.niceSelects) {
          return null;
        }

        var selects = getSelects(quickFilter);

        if (!selects.make || !selects.model) {
          return null;
        }

        return {
          quickFilter: quickFilter,
          selects: selects
        };
      },
      root,
      restoreId,
      function (context) {
        context.selects.make.selectedIndex = 0;
        context.selects.model.selectedIndex = 0;
        context.selects.model.disabled = true;

        updateNiceSelect(
          context.quickFilter,
          context.selects.make
        );
        updateNiceSelect(
          context.quickFilter,
          context.selects.model
        );

        var button = context.quickFilter.querySelector(
          '.js-filter-submit'
        );

        if (button) {
          button.setAttribute('disabled', 'disabled');
        }

        root.removeAttribute('data-lcm-home-vehicle-restored');
      },
      0
    );
  }

  function restoreAll(force) {
    var activeVehicle = getActiveVehicle();

    if (typeof activeVehicle === 'undefined') {
      apiRetryCount += 1;

      if (apiRetryCount > MAX_ATTEMPTS) {
        return;
      }

      window.setTimeout(function () {
        restoreAll(force);
      }, RETRY_DELAY);
      return;
    }

    apiRetryCount = 0;

    if (!activeVehicle && !force) {
      return;
    }

    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (!force && root.__lcmHomeUserInteracted) {
        return;
      }

      if (activeVehicle) {
        restoreVehicle(root, activeVehicle);
      } else {
        clearVehicle(root);
      }
    });
  }

  function cancelRestoreOnInteraction(event) {
    var root = event.target.closest(ROOT_SELECTOR);

    if (!root) {
      return;
    }

    root.__lcmHomeUserInteracted = true;
    root.__lcmHomeRestoreId = (root.__lcmHomeRestoreId || 0) + 1;
  }

  document.addEventListener('pointerdown', cancelRestoreOnInteraction, true);
  document.addEventListener('keydown', cancelRestoreOnInteraction, true);

  window.addEventListener('lcm:vehiclechange', function () {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      root.__lcmHomeUserInteracted = false;
    });

    restoreAll(true);
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(function () {
      restoreAll(false);
    }, 0);
  });

  function initialize() {
    restoreAll(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();